export const staticTextErrors = {
  SERVER_ERROR: "Something went wrong! Please try again later.",
};
